module.exports = __webpack_public_path__ + "img/loading.3f6c4daa.gif";